import * as React from 'react'
import type { SVGProps } from 'react'
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33333 4.28174C2.8731 4.28174 2.5 4.65483 2.5 5.11507V5.84895L10 10.5156L17.5 5.84895V5.11507C17.5 4.65483 17.1269 4.28174 16.6667 4.28174H3.33333ZM17.5 7.5156L10 12.1823L2.5 7.5156V15.9484C2.5 16.4086 2.8731 16.7817 3.33333 16.7817H16.6667C17.1269 16.7817 17.5 16.4086 17.5 15.9484V7.5156ZM0.833333 5.11507C0.833333 3.7343 1.95262 2.61507 3.33333 2.61507H16.6667C18.0474 2.61507 19.1667 3.7343 19.1667 5.11507V15.9484C19.1667 17.3291 18.0474 18.4484 16.6667 18.4484H3.33333C1.95262 18.4484 0.833333 17.3291 0.833333 15.9484V5.11507Z"
      fill="#4F5277"
    />
  </svg>
)
export default SvgMail
